import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ComponentTypeEnum } from '../enums/component-type.enum';
import { LandingPageComponentAlignment } from '../enums/landing-page-component-alignment.enum';
import { ILandingPageComponentQuery } from '../interfaces/landing-page-component-query.interface';
import { LandingPageComponentListing } from './landing-page-component-listing.model';
import { LandingPageComponentPermission } from './landing-page-component-permission.model';

export class LandingPageComponent {
    id: string;
    image: MaxbrainImage | null;
    paragraph: string | null;
    sequence: number;
    title: string | null;
    type: string;
    alignment: LandingPageComponentAlignment;
    listings: LandingPageComponentListing[] = [];
    permissions: LandingPageComponentPermission[] = [];

    constructor(query: ILandingPageComponentQuery) {
        this.id = query.id.toString();
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.paragraph = query.paragraph;
        this.sequence = query.sequence;
        this.title = query.title;
        this.type = query.type;
        this.alignment = this.resolveAlignment(query.alignment);
        this.listings = (query.listings || []).map((listing) => new LandingPageComponentListing(listing));
        this.permissions = (query.permissions || []).map((permission) => new LandingPageComponentPermission(permission));
    }

    get hasTitleContent(): boolean {
        return !!this.title?.trim();
    }

    get hasParagraphContent(): boolean {
        return !!this.paragraph?.trim();
    }

    get hasImageContent(): boolean {
        return !!this.image;
    }

    get hasVisibleContent(): boolean {
        switch (this.type) {
            case ComponentTypeEnum.TITLE:
                return this.hasTitleContent;
            case ComponentTypeEnum.PARAGRAPH:
                return this.hasParagraphContent;
            case ComponentTypeEnum.IMAGE:
                return this.hasImageContent;
            case ComponentTypeEnum.IMAGE_AND_PARAGRAPH:
                return this.hasImageContent || this.hasParagraphContent;
            case ComponentTypeEnum.LISTING:
                return true;
            default:
                return true;
        }
    }

    private resolveAlignment(alignment: string | null | undefined): LandingPageComponentAlignment {
        if (alignment === LandingPageComponentAlignment.Left || alignment === LandingPageComponentAlignment.Right) {
            return alignment;
        }

        return LandingPageComponentAlignment.Center;
    }
}
